<template>
  <div class="google-form">
    <div class="modal google-form-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card" @click="closeModal">
        <section class="modal-card-body">
          <!-- <h1 class="has-text-link is-size-5 has-text-weight-semibold">{{ $t("install-ios-title") }}</h1> -->
          <!-- <iframe :src="url" style="height:65vh; width:auto"></iframe> -->
          <!-- src="https://docs.google.com/forms/d/e/1FAIpQLSfa5FRqniIs2Ewsyl3xhJZ6Q6ik50be1nO9-iJHimYNivLCGA/viewform?embedded=true?hl=jp" -->
          <iframe
            :src="url"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            width="640"
            height="1703"
            style="height:65vh; z-index:10000;"
          >Loading…</iframe>
          <br />
          <a class="button is-link" @click="closeModal">{{ $t("close") }}</a>
        </section>
      </div>
      <button class="modal-close is-large is-grey" aria-label="close" @click="closeModal"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoogleFormModal",
  computed: {
    url() {
      return this.$t("url.school-service-form");
    }
  },
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  padding: 10px;
}
</style>